import { getIdfcAuthUrl } from "_services";
import { useCallback } from "react";
import toast from "react-hot-toast";

const useGetAuthUrl = () => {
  const getAuthUrl = useCallback(async (item) => {
    try {
      const param = {
        referenceNumber: item.referenceNumber,
      };
      const res = await getIdfcAuthUrl(param);

      if (res?.responseCode === 200 && res?.data?.authURL) {
        return res.data.authURL;
      } else {
        toast.error("Something went wrong.");
        return null;
      }
    } catch (error) {
      console.error("Submission Error:", error);
      return null;
    }
  }, []);

  return { getAuthUrl };
};

export default useGetAuthUrl